module.exports = __webpack_public_path__ + "img/quiz-cup.2d3b0618.svg";